"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var style = __importStar(require("./Alert.style"));
var AlertContext_1 = require("./AlertContext");
var CloseButton = function (_a) {
    var onClick = _a.onClick, variant = _a.variant;
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ css: style.closeButton(variant), onClick: onClick, width: "12", height: "12", viewBox: "0 0 12 12", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M11.0469 9.57617C11.3457 9.9082 11.3457 10.4062 11.0469 10.7051C10.7148 11.0371 10.2168 11.0371 9.91797 10.7051L6 6.75391L2.04883 10.7051C1.7168 11.0371 1.21875 11.0371 0.919922 10.7051C0.587891 10.4062 0.587891 9.9082 0.919922 9.57617L4.87109 5.625L0.919922 1.67383C0.587891 1.3418 0.587891 0.84375 0.919922 0.544922C1.21875 0.212891 1.7168 0.212891 2.01562 0.544922L6 4.5293L9.95117 0.578125C10.25 0.246094 10.748 0.246094 11.0469 0.578125C11.3789 0.876953 11.3789 1.375 11.0469 1.70703L7.0957 5.625L11.0469 9.57617Z", fill: "currentColor" }) })));
};
var CloseButtonWrapper = function (props) { return ((0, jsx_runtime_1.jsx)(AlertContext_1.Consumer, { children: function (alertContext) {
        var variant = alertContext.variant;
        return (0, jsx_runtime_1.jsx)(CloseButton, __assign({ variant: variant }, props));
    } })); };
exports.default = CloseButtonWrapper;
//# sourceMappingURL=CloseButton.js.map